/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ws_Plan_GeneratingInputs */

const en_ws_plan_generating = /** @type {(inputs: Ws_Plan_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still generating…`)
};

const id_ws_plan_generating = /** @type {(inputs: Ws_Plan_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih disusun…`)
};

/**
* | output |
* | --- |
* | "Still generating…" |
*
* @param {Ws_Plan_GeneratingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_plan_generating = /** @type {((inputs?: Ws_Plan_GeneratingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Plan_GeneratingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_plan_generating(inputs)
	return en_ws_plan_generating(inputs)
});